import React, { useEffect, useState } from 'react';
import { Form, notification } from 'antd';
import AddUpdateIndicatorMapping from './component/IndicatorMapping';
import IndicatorsMapping from './IndicatorsMapping';
import { RootState, useAppDispatch } from '../../../app/store';
import { useSelector } from 'react-redux';
import { fetchIndicatorsMinistriesMappingList, mapIndicatorsMinistry, deleteIndicatorsMinistry } from './indicatorsMappingApi';
import { fetchIndicators, fetchMinistries } from '../../master/masterApi';
import { convertToTreeData, uniqueObjects } from '../../../utils/commonFunctions';
import { useTranslation } from 'react-i18next';

interface IndicatorMappingContainerProps {

}

const IndicatorMappingContainer: React.FC<IndicatorMappingContainerProps> = (props) => {
    const [form] = Form.useForm();
    const [isAddUpdateMapping, setIsAddUpdateMapping] = useState<boolean>(false);
    const [selectedMinistryId, setSelectedMinistryId] = useState();
    const [selectedFilters, setSelectedFilters] = useState<number[]>([]);
    const [isAllSelected, setIsAllSelected] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { ministryIndicators } = useSelector((state: RootState) => state.indicatorsMapping);
    const { indicators, ministries } = useSelector((state: RootState) => state.masterData);

    useEffect(() => {
        dispatch(fetchIndicatorsMinistriesMappingList());
    }, [dispatch, isAddUpdateMapping]);

    //Fetch indicator master list if already not loaded
    useEffect(() => {
        if (!(indicators?.length)) {
            dispatch(fetchIndicators());
        }
    }, [dispatch, indicators]);

    //Handle click event on edit ministry on indicator ministry mapping list
    const onHandleMinistryUpdate = (value?: any) => {
        if (!(ministries?.length)) {
            dispatch(fetchMinistries());
        }
        setSelectedMinistryId(value);
        setIsAddUpdateMapping(true);
    };

    const onHandleMinistryDelete = (ministryId: any) => {
        const finalObject = {
            nodeId: ministryId,
        };

        dispatch(deleteIndicatorsMinistry(finalObject))
            .unwrap()
            .then((response) => {

                form.resetFields();
                if (response?.status === 'success') {
                    notification.success({ message: t('success'), description: response?.message });
                    dispatch(fetchIndicatorsMinistriesMappingList());
                }
                setIsAddUpdateMapping(false)
            });
    };


    // Collect indicators that are associated with ministries including their ID
    const associatedIndicators = Array.from(
        new Set(
            ministryIndicators.flatMap(ministry =>
                ministry.indicators.map((indicator: any) => ({
                    id: indicator.id,
                    name: indicator.name
                }))
            )
        )
    );

    //Collect uniq indicators from the associated indicators
    const uniqAssociatedIndicators = uniqueObjects(associatedIndicators);

    //Handle indicator filter check box change event
    const onFilterChanged = (value: number[]) => {
        setSelectedFilters(value);
        setIsAllSelected(value.length === uniqAssociatedIndicators.length);
    }

    // Filter ministries based on selected filters
    const filteredMinistries = ministryIndicators.filter(ministry =>
        selectedFilters.length === 0 ||
        ministry?.indicators?.some((indicator: any) => selectedFilters.includes(indicator.id))
    );

    return (
        <>
            <IndicatorsMapping
                ministries={filteredMinistries}
                filterSelectedIndicators={selectedFilters}
                associatedIndicators={uniqAssociatedIndicators ?? []}
                filterOnChange={onFilterChanged}
                isAllSelected={isAllSelected}
                handleMapMinistry={(value) => onHandleMinistryUpdate(value)}
                handleDeleteMinistry={(ministryId) => onHandleMinistryDelete(ministryId)} />

        </>
    );
};

export default IndicatorMappingContainer;